/**
 * Детерминированный градиент-плейсхолдер обложки трека. У треков без своей
 * обложки (Mureka вообще не отдаёт обложки; старые Suno-треки — часть) вместо
 * одинакового пустого квадрата показываем уникальный градиент, посеянный по
 * id трека — стабильный между рендерами, разный у каждого трека (как в
 * Spotify/SoundCloud). Чисто фронтовый, без сети и кредитов.
 */

/** Стабильный 32-bit хэш строки (FNV-подобный). */
function hashSeed(s: string): number {
	let h = 2166136261
	for (let i = 0; i < s.length; i++) {
		h ^= s.charCodeAt(i)
		h = Math.imul(h, 16777619)
	}
	return h >>> 0
}

/** CSS-градиент для фона плейсхолдера обложки. seed — обычно track.id.
 *  Два связанных оттенка по диагонали; средняя насыщенность и тёмная
 *  светлота, чтобы белый глиф/текст читался на обеих темах. */
export function coverGradient(seed: string | null | undefined): string {
	const h = hashSeed(seed || 'track')
	const hue1 = h % 360
	const hue2 = (hue1 + 35 + ((h >> 9) % 70)) % 360
	return `linear-gradient(135deg, hsl(${hue1} 52% 40%), hsl(${hue2} 58% 27%))`
}
